module.exports = __webpack_public_path__ + "media/images/apple-icon-76x76-0014ebe1.png";